import React from 'react';
import { useCssHandles } from '../../utils/functions';
import FirstLevel from './FirstLevel';
import SecondLevel from './SecondLevel';
import { selectFirstLevel, selectMenuState } from '../../redux/megaMenuSlice';
import { useDispatch, useSelector } from 'react-redux';
import './megaMenuStyles.scss';

const CSS_HANDLES = [
	'menuContainerNavVertical',
	'departmentsContainer',
	'departmentsTitle',
	'menuContainerVertical',
	'submenuContainerVertical',
	'submenuContainerTitle',
	'submenuListVertical',
];
const MegaMenuVertical = ({ title = 'Departments', blockClass = '', orientation, openOnly, isMobile, componentId }) => {
	const { handles } = useCssHandles('vtex-mega-menu-2-x', CSS_HANDLES, blockClass);
	const selectedFirstLevel = useSelector(selectFirstLevel);
	const isOpenMenu = useSelector(selectMenuState);

	return (isOpenMenu && openOnly === orientation) || isMobile ? (
		<nav data-selection={componentId} className={`${handles.menuContainerNavVertical} w-100`}>
			<div
				className={`${handles.departmentsContainer} ${selectedFirstLevel || (selectedFirstLevel == 0 && isMobile) ? 'dn' : ''}`}
			>
				<h3 className={`${handles.departmentsTitle} f4 fw7 c-on-base mv5 lh-copy ph5`}>{title}</h3>
				<ul className={`${handles.menuContainerVertical} list pa0`}>
					{dummyData.map((category, index) => (
						<FirstLevel {...{ ...category, blockClass, index }} isSelected={index == selectedFirstLevel} />
					))}
				</ul>
			</div>
			{dummyData[selectedFirstLevel] && (
				<div className={`${handles.submenuContainerVertical} bg-base w-100`}>
					<h3 className={`${handles.submenuContainerTitle} f4 fw7 c-on-base lh-copy ma0 flex items-center pv5 ph5`}>
						{dummyData[selectedFirstLevel].name}
					</h3>
					<div className={`${handles.submenuListVertical}`}>
						{dummyData[selectedFirstLevel]?.items.map((level, index) => {
							return <SecondLevel key={`mm-second-level-${index}`} {...{ ...level, blockClass }} />;
						})}
					</div>
				</div>
			)}
		</nav>
	) : null;
};

export default MegaMenuVertical;

const dummyData = [
	{
		name: 'Categoria 1',
		items: [
			{
				name: 'Sub 1',
				items: [
					{ name: 'Terceiro nível 1' },
					{ name: 'Terceiro nível 2' },
					{ name: 'Terceiro nível 3' },
					{ name: 'Terceiro nível 4' },
					{ name: 'Terceiro nível 5' },
					{ name: 'Terceiro nível 6' },
				],
			},
			{ name: 'Sub 2' },
			{ name: 'Sub 3' },
			{ name: 'Sub 4' },
			{ name: 'Sub 5' },
			{ name: 'Sub 6' },
		],
	},
	{ name: 'Categoria 2', items: [] },
	{ name: 'Categoria 3', items: [] },
	{ name: 'Categoria 4', items: [] },
	{ name: 'Categoria 5', items: [] },
	{ name: 'Categoria 6', items: [] },
];
